import React from 'react';

import './index.css';

import MainLayout, { IMainLayoutProps } from 'client/common/components/main-layout';

export default (props: Exclude<IMainLayoutProps, 'content'>) =>
    <MainLayout {...props} content={['left', 'right', 'middle']} />;
